export default {
  path: "/",
  name: "home_base",
  component: () => import("@/views/home/HomeBase.vue"),
  children: [
    {
      path: "",
      name: "home_landing",
      component: () => import("@/views/home/Landing.vue")
    },
    {
      path: "/signup/:referrer?",
      name: "home_signup",
      component: () => import("@/views/home/Signup.vue")
    },
    {
      path: "/login",
      name: "home_login",
      component: () => import("@/views/home/Login.vue")
    },
    {
      path: "/brokerage",
      name: "home_brokerage",
      component: () => import("@/views/home/Brokerage.vue")
    },
    {
      path: "/demo", //view_sample_application
      name: "home_demo",
      component: () => import("@/views/home/Demo.vue"),
      children: [
        {
          path: "summary",
          name: "home_demo_summary",
          component: () => import("@/views/dashboard/view_application/Summary.vue")
        },
        {
          path: "application",
          name: "home_demo_application",
          component: () => import("@/views/dashboard/view_application/Application.vue")
        },
        {
          path: "report/:type",
          name: "home_demo_report",
          component: () => import("@/views/dashboard/view_application/Report.vue")
        }
      ]
    },
    {
      path: "/password_reset",
      name: "home_password_reset",
      component: () => import("@/views/home/PasswordReset.vue")
    },
    //due to supporting legacy path
    {
      path: "/accounts/password_reset",
      redirect: { name: "home_password_reset" }
    },
    {
      path: "/accounts/reset/:uidb64/:token",
      name: "home_password_reset_confirm",
      component: () => import("@/views/home/PasswordResetConfirm.vue")
    },
    {
      path: "/password_reset/done",
      name: "home_password_reset_done",
      component: () => import("@/views/home/PasswordResetDone.vue")
    },
    {
      path: "/support",
      name: "home_support",
      component: () => import("@/views/home/Support.vue")
    },
    {
      path: "/privacy",
      name: "home_privacy",
      component: () => import("@/views/home/Privacy.vue")
    },
    {
      path: "/terms",
      name: "home_terms",
      component: () => import("@/views/home/Terms.vue")
    },
    {
      path: "/terms/ambassador",
      name: "home_ambassador_terms",
      component: () => import("@/views/home/AmbassadorTerms.vue")
    },
    {
      path: "/terms/my_payments",
      name: "home_my_payments_terms",
      component: () => import("@/views/home/MyPaymentsTerms.vue")
    },
    {
      path: "/security",
      name: "home_security",
      component: () => import("@/views/home/Security.vue")
    },
    {
      path: "/applicant-warning-message",
      name: "home_applicant_warning_message",
      component: () => import("@/views/home/ApplicantWarningMessage.vue")
    },
    {
      path: "/how-to-get-verified-for-credit-reports",
      name: "home_how_to_get_verified_for_credit_reports",
      component: () => import("@/views/home/HowToGetVerifiedForCreditReports.vue")
    },
    {
      path: "/applicant-ssn",
      name: "home_applicant_ssn",
      component: () => import("@/views/home/ApplicantSSN.vue")
    },
    {
      path: "/applicants",
      name: "home_applicants",
      component: () => import("@/views/home/Applicants.vue")
    },
    {
      path: "/report-accuracy",
      name: "home_report_accuracy",
      component: () => import("@/views/home/ReportAccuracy.vue")
    },
    {
      path: "/applicant-benefits",
      name: "home_applicant_benefits",
      component: () => import("@/views/home/ApplicantBenefits.vue")
    },
    {
      path: "/free-rental-application-pdf",
      name: "home_free_rental_application_pdf",
      component: () => import("@/views/home/FreeRentalApplicationPdf.vue")
    }
  ]
}
